import { validateModificationAction } from "./applyRecipientsImportModifications"
import { RecipientModificationAction, RecipientModifications } from "./types"

export const onChangeKeppDeleteds = (
    modifications: RecipientModifications[],
    keepDeleteds: boolean
): RecipientModifications[] => {
    modifications
        .filter(
            modification =>
                modification.action === RecipientModificationAction.DELETED ||
                modification.action === RecipientModificationAction.PRESERVED
        )
        .forEach(modification => {
            if (keepDeleteds) modification.action = RecipientModificationAction.PRESERVED
            else modification.action = RecipientModificationAction.DELETED
        })
    return modifications
}

export const onChangeOverrideUpdateds = (
    modifications: RecipientModifications[],
    overrideUpdateds: boolean
): RecipientModifications[] => {
    modifications
        .filter(
            modification =>
                modification.action === RecipientModificationAction.UPDATED ||
                modification.action === RecipientModificationAction.OVERRIDED
        )
        .forEach(modification => {
            if (overrideUpdateds) modification.action = RecipientModificationAction.OVERRIDED
            else modification.action = RecipientModificationAction.UPDATED

            modification.actionErrors = validateModificationAction(modification)
        })
    return modifications
}
